import '~/js/libs/jquery.waypoint';
import '~/js/libs/sticky';

// Variable Declaration
const menu = document.getElementById('nav');
const toggleButton = document.getElementById('menu-click');
const isFixedNav = menu.classList.contains('fixed-nav');

// Internals Variables
const internals = {
    options: {
        element: menu,
        offset: 33,
        stuckClass: 'stuck'
    }
};

// Sticky Nav
if (!isFixedNav) {
    new window.Waypoint.Sticky(internals.options);
}

// Toggle Sticky Nav
toggleButton.addEventListener('click', () => menu.classList.toggle('open'));

document.body.addEventListener('click', (event) => {
    if (($(event.target).parents('#nav').length <= 0) && (menu.classList.contains('open'))) {
        menu.classList.remove('open');
    }
});
